import React from 'react';
import { BasicTheme, Header } from 'react-design-components';

export interface Props {
  error: Error;
  componentStack: string | null;
  eventId: string | null;
}

export const FallbackContainer = ({ error, componentStack }: Props): React.ReactElement => (
  <div style={{ textAlign: 'center' }}>
    <div>
      <h1>Es ist ein unerwarteter Fehler aufgetreten</h1>
      <p>
        Unsere Techniker wurde automatisch über diesen Fehler benachrichtigt und werden dieses schnellstmöglichst
        bearbeiten.
        <br />
        Sie können uns gern unter <a href="mailto:info@mineko.de">info@mineko.de</a> kontaktieren oder Sie versuchen es
        erneut über <a href="https://www.mineko.de/">mineko.de</a>.
      </p>
    </div>
    <div>
      <details>
        {error?.name}
        <br />
        {error?.message}
        <br />
        {error?.stack}
        <br />
        {componentStack}
      </details>
    </div>
  </div>
);

const ErrorFallback: React.FunctionComponent<Props> = (props) => {
  return (
    <BasicTheme>
      <Header
        withTrust={false}
        logoClaimText="Engineering"
        claim=""
        logoOnClick={() => window.location.assign('https://www.mineko.de/')}
      />
      <FallbackContainer {...props} />
    </BasicTheme>
  );
};

export default ErrorFallback;
